import React from 'react';
import PropTypes from 'prop-types';
import {makeParser} from 'generic/MarkdownRendererV2/markdownRendererUtils';
import supplementStore from 'client/Supplement/SupplementStore';
import connectToStores from 'lib/decorators/connectToStores';

import {mapReactTreeWithHighlights} from '../../utils/highlighting';

@connectToStores(supplementStore)
export default class BasicRenderer extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    highlight: PropTypes.string
  };

  createOutput() {
    const {highlight = ''} = this.props;

    const parser = makeParser();
    const syntaxTree = parser.makeSyntaxTree(this.props.text);
    const reactTree = parser.reactOutput(syntaxTree);

    if (!highlight || !highlight.trim()) {
      return reactTree;
    }

    // if a section of the reactTree needs to be highlighted,
    // we need to traverse the tree and replace text nodes with highlighted parts
    if (Array.isArray(reactTree)) {
      return reactTree.map((n, i) => (
        <React.Fragment key={`basic-renderer-${i}`}>
          {mapReactTreeWithHighlights(n, highlight)}
        </React.Fragment>
      ));
    }

    return mapReactTreeWithHighlights(reactTree, highlight);
  }

  render() {
    return <>{this.createOutput()}</>;
  }
}
